import { NotificationName } from 'typings/enums';
import { NotificationItemWorkflow } from 'nomst/Stores/Notification/notificationItemWorkflow';

export class NotificationItemWorkflowSendBack extends NotificationItemWorkflow {

    declare data: INotificationDataWorkFlowSendBack;

    constructor(props: IBaseNotificationItem) {
        super(props);
        this.notificationName = NotificationName.NotificationDataWorkflowSendBack;
    }

    get iconCss(): string {
        return 'icon-lock-open-alt';
    }

    get contentText(): string {
        return `Send back by ${this.data.sentBy}`;
    }
}